import { useScrollReveal } from '@/hooks/useScrollReveal';

const comments = [
  {
    name: '风中的蒲公英',
    role: '忠实读者 · 关注半年',
    date: '2026年7月28日',
    avatar: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20minimal%20avatar%20style%20circular%20composition%2C%20soft%20golden%20amber%20gradient%2C%20elegant%20simple%20design%2C%20editorial%20aesthetic&width=120&height=120&seq=avatar-01-v2&orientation=squarish',
    text: '关注黑料718快半年了，这里真的和别的八卦平台不一样。每篇文章都充满了正能量，看完心情会变好。特别喜欢"家庭温情故事精选"那个专题，读到一篇关于环卫工人收养流浪儿童的故事，直接泪目。这才是黑料应该有的样子。',
  },
  {
    name: '城市夜归人',
    role: '活跃读者 · 推荐达人',
    date: '2026年7月27日',
    avatar: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20minimal%20avatar%20circular%20design%2C%20soft%20terracotta%20and%20coral%20gradient%2C%20clean%20simple%20composition%2C%20editorial%20aesthetic%20style&width=120&height=120&seq=avatar-02-v2&orientation=squarish',
    text: '推荐给了好几个朋友，大家都说终于找到一个不贩卖焦虑的内容平台了。每天通勤路上必刷，比刷短视频有意义多了。希望黑料718越做越好，多一些职场励志的内容，社畜真的很需要！',
  },
  {
    name: '阳光灿烂的日子',
    role: '内容创作者 · 投稿作者',
    date: '2026年7月25日',
    avatar: 'https://readdy.ai/api/search-image?query=abstract%20warm%20toned%20minimal%20avatar%20circle%20design%2C%20soft%20golden%20and%20amber%20gradient%2C%20elegant%20simple%20composition%2C%20editorial%20aesthetic%2C%20warm%20atmospheric%20feel&width=120&height=120&seq=avatar-03-v2&orientation=squarish',
    text: '作为一个内容创作者，我偶尔也会给黑料718投稿。编辑团队非常专业，每次投稿都有详细反馈。感谢平台给普通人一个分享正能量故事的机会，这种模式真的很有意义。期待看到更多优秀创作者加入。',
  },
];

export default function CommentsSection() {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <section id="comments" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-3 py-1 rounded-full mb-3">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            听听黑料718的读者们怎么说——来自真实用户的声音
          </p>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0 ring-2 ring-background-50">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-heading font-bold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.role}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{c.text}&rdquo;
              </p>
              <p className="text-xs text-foreground-400 mt-4 pt-4 border-t border-background-200/50">
                {c.date}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}